<template>
  <div class="visit-success-page">
    <img src="../assets/face logo.png">

    <div class="info">
      Wichtige Information zum Thema COVID-19 / Contact-Tracing
    </div>

    <div class="title">
      Face Club COVID-19 Tracking
    </div>

    <div class="subtitle">
      Diese Liste ermöglicht den Contact Tracing im Rahmen des Schutzkonzeptes der Face Club.
    </div>

    <div class="subtitle">
      Deine Kontaktdaten werden für bestimmte Zeit gespeichert um es den Gesundheitsbehörden zu ermöglichen, dich im
      Falle eines COVID-19 Falles zu informieren.
    </div>

    <div class="subtitle">

      Du musst dich nur einmalig auf dieser Liste eintragen und bist dann permanent auf der Liste am Eingang.
    </div>

    <div class="success">
      Vielen Dank, <br/>
      du bist eingetragen!
    </div>
  </div>
</template>

<script>
  export default {
    name: "VisitSuccessPage",
  }
</script>

<style lang="scss">
  @import "VisitSuccessPage";
</style>
